import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/duplicate-customer'
import {format} from 'utils'

export async function list(params) {
    return request(`${api.list.url}?${stringify(params)}`)
}

export async function followUsers(payload) {
    return request(format(api.followUsers.url, {external_userid: payload.externalUserId}))
}
